import { AutocompleteItem } from '@app/forms/formly/types/input-field-with-autocomplete/input-field-with-autocomplete.component';

export function filterAutocompleteItems(
  filterValue: string,
  items: AutocompleteItem[],
): AutocompleteItem[] {
  const result: AutocompleteItem[] = [];
  items.forEach((item) => {
    const newItem = { ...item };
    const options = newItem.options;
    const filteredOptions = options.filter(
      (option) =>
        option.title.toLowerCase().includes(filterValue) ||
        option.value.toLowerCase().includes(filterValue) ||
        [option.title, option.suffix].join(' ').toLowerCase().includes(filterValue) ||
        option.suffix?.toLowerCase().includes(filterValue),
    );
    newItem.options = filteredOptions;

    if (newItem.options.length > 1) {
      newItem.options = newItem.options.map((item) => ({
        ...item,
        icons: ['subdirectory_arrow_right', ...(item.icons ?? [])],
      }));
    }

    if (filteredOptions.length) {
      result.push(newItem);
    }
  });

  return result;
}
